import {
  Alert,
  AlertIcon,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@elkaso-app/web-design';
import React from 'react';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName: string;
  isLoading?: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
  isLoading = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size='md'>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Source Brand Location</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack spacing={4} align='stretch'>
            <Alert status='warning'>
              <AlertIcon />
              This action cannot be undone.
            </Alert>

            <Text>
              Are you sure you want to delete the location <strong>{itemName}</strong>?
            </Text>

            <Text fontSize='sm' color='gray.600'>
              This will permanently remove the location and all its associated data.
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant='ghost' mr={3} onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button colorScheme='red' onClick={onConfirm} isLoading={isLoading} loadingText='Deleting...'>
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteConfirmationModal;
